module.exports = __webpack_public_path__ + "comments/production/img/avatar_organizer.e230e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_organizer.png
// module id = i6Hc
// module chunks = 0